module.exports = __webpack_public_path__ + "assets/media/m1.79e64003.mp4";